import React, { useEffect, useRef, useState } from "react";
import {
  creativeApproveAndRejectRoles,
  creativeClientRejectApproveAccess,
  creativeHeaders,
  creativeUploadHeaders,
  creativeUploadRoles,
  getAllRequestsByAccountName,
  reassignRequestAccess,
} from "./CreativeConstants";
import SearchBox from "../../components/common/SearchBox";
import CreativeDialog from "./CreativeDialog";
import UploadCreative from "./UploadCreative";
import { useDispatch, useSelector } from "react-redux";
import {
  getPendingCreatives,
  getApprovedCreatives,
  getRejectedCreatives,
  approveCreative,
  getCreatives,
  convertPSDImage
} from "../../redux/slices/apiSlice";
import CreativeTable from "./CreativeTable";
import RightSidebar from "../../components/common/RightSidebar";
import { ActionDropdown } from "./ActionDropdown";
import Loader from "../../utils/Loader";
import { showAlert } from "../../utils";
import FolderDialog from "../repository/FolderDialog";
import downloadIcon from "../../assets/images/downloadIcon.svg";
import moment from "moment";
import fileIcon from '../../assets/images/file.png'
import { getFileIcon } from "../../utils";
import MediaViewerDialog from "./MediaViewerDialog";
import { useApp } from "../../utils/AppContext";



const CreativeApproval = () => {
  const [query, setQuery] = useState("");
  const [openCreativeUpload, setOpenCreativeUpload] = useState(false);
  const [openMediaViewer, setOpenMediaViewer] = useState(false);
  const { notificationCreativePayload, setNotificationCreativePayload } = useApp();

  const dispatch = useDispatch();
  const {
    pendingCreativeData,
    approvedCreativesData,
    getRejectedCreativeData,
    isCreativeUploaded,
    getCreativeData,
  } = useSelector((state) => state.api);
  const [creativeData, setCreativeData] = useState([]);
  const [approvedCreativeDataList, setApprovedCreativeDataList] = useState([]);
  const [rejectedCreativeDataList, setRejectedCreativeDataList] = useState([]);
  const [creativeTab, setCreativeTab] = useState("Assigned");
  const [user, setUser] = useState();
  const [openReqSidebar, setOpenReqSidebar] = useState(false);
  const [requestDetails, setRequestDetails] = useState([]);
  const [accountName, setAccountName] = useState([]);
  const [reassignedCreativeItem, setReassignedCreativeItem] = useState(null);
  const token = sessionStorage.getItem("token");
  const userRole = JSON.parse(sessionStorage.getItem("user"))?.role;
  const [psdImageData, setPsdImageData] = useState(null);
  const decodeJWT = (token) => {
    if (!token) return null;

    // Split the token into its parts (Header, Payload, Signature)
    const [header, payload, signature] = token.split(".");

    // Function to decode base64url to a regular base64
    const base64UrlToBase64 = (base64Url) => {
      return base64Url.replace(/-/g, "+").replace(/_/g, "/");
    };

    // Decode the payload (second part of the JWT)
    const decodedPayload = JSON.parse(atob(base64UrlToBase64(payload)));

    return decodedPayload;
  };

  useEffect(() => {
    const decodedToken = decodeJWT(token);

    if (decodedToken) {
      const clients = JSON.parse(decodedToken["custom:clients"]);
      setAccountName(clients[0].account_name);
    }
  }, [token]);

  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  useEffect(() => {
    if(notificationCreativePayload && notificationCreativePayload?.creativeId){
          setOpenReqSidebar(true);
          setRequestDetails(notificationCreativePayload?.creativeId);
          setNotificationCreativePayload(null);
    }
  }, [notificationCreativePayload]);

  useEffect(() => {
    if (user) {
      if (getAllRequestsByAccountName.includes(userRole)) {
        dispatch(
          getCreatives({
            payload: { userId: user?._id, account_name: accountName },
          })
        );
      } else {
        dispatch(
          getCreatives({
            payload: { userId: user?._id },
          })
        );
      }
    }
  }, [dispatch, user, userRole]);

  useEffect(() => {
    if (getCreativeData) {
      setCreativeData(getCreativeData);
    }
  }, [getCreativeData]);

  // const filteredData = (
  //   creativeTab === "Assigned"
  //     ? creativeData
  //     : creativeTab === "Approved"
  //     ? approvedCreativeDataList
  //     : creativeTab === "Rejected"
  //     ? rejectedCreativeDataList
  //     : []
  // )?.filter((item) =>
  //   item?.requestName?.toLowerCase()?.includes(query.trim().toLowerCase())
  // );

  const filteredData = creativeData?.filter((item) =>
    item?.requestName?.toLowerCase()?.includes(query.trim().toLowerCase())
  );

  const handleDownload = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileUrl.split("/").pop();
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const convertPSDImageHandler = async (creativeData) => {
    let response = await dispatch(
      convertPSDImage({ s3Url: creativeData.s3_file_name })
    )
    if(!response.payload || response.error) setPsdImageData({error: response.error || "Server Errror"});
    response?.payload?.imageDataUrl && setPsdImageData(response.payload.imageDataUrl)
  }

  const reAssignAlert = async (userId, requestId, userEmail) => {
    const value = await showAlert({
      title: <span className="text-[18px]"></span>,
      text: "Are you sure you want to re-open this request?",
      cancelButtonText: "Cancel",
      confirmButtonText: "Confirm",
    });
    if (value) {
      dispatch(
        approveCreative({
          payload: {
            userID: userId,
            userEmail: userEmail,
            creativeId: requestId,
            isApproved: false,
            status: "Rejected",
            reOpenRequest: true,
          },
        })
      ).then(() => {
        if (getAllRequestsByAccountName.includes(userRole)) {
          dispatch(
            getCreatives({
              payload: { userId: user?._id, account_name: accountName },
            })
          );
        } else {
          dispatch(
            getCreatives({
              payload: { userId: user?._id },
            })
          );
        }
      });
    }
  };
  return (
    <div className="flex flex-col gap-5 max-h-[95vh] overflow-scroll scroll-smooth pb-10">
      <h2 class="pageHeading mb-0">creative approval</h2>
      {isCreativeUploaded ? <Loader /> : <></>}
      <div className="flex gap-3 justify-between items-center w-full">
        <SearchBox query={query} setQuery={setQuery} />
        {creativeUploadRoles.includes(user?.role) && (
          <button
            className="py-2 px-4 w-[176px] h-[40px] font-medium text-white text-nowrap text-sm transition-all duration-700 ease-in-out hover:bg-black bg-[#1890FF] shadow-sm rounded"
            onClick={() => setOpenCreativeUpload(true)}
          >
            + Add New Request
          </button>
        )}
      </div>
      <CreativeDialog
        isOpen={openCreativeUpload}
        content={
          <UploadCreative
            user={user}
            userRole={userRole}
            accountName={accountName}
            close={() => setOpenCreativeUpload(false)}
            reassignedCreativeItem={reassignedCreativeItem}
            setReassignedCreativeItem={setReassignedCreativeItem}
            openCreativeUpload={openCreativeUpload}
          />
        }
        onClose={() => setOpenCreativeUpload(false)}
        setReassignedCreativeItem={setReassignedCreativeItem}
        title="Upload Creative"
      />
      {
        openMediaViewer ?

          ["application/x-photoshop"].includes(requestDetails?.file_type) && !psdImageData 

            ?

            <Loader />
            : 

            <MediaViewerDialog
              isOpen={openMediaViewer}
              content={
                <div className="flex justify-center items-center">
                  {
                    requestDetails?.file_type?.startsWith('image/') ?
                      <img
                        alt=""
                        className={`rounded w-full object-cover`}
                        src={requestDetails.s3_file_name}
                      />
                      : requestDetails?.file_type?.startsWith('video/') ?
                        <video
                          className={`rounded w-full object-cover`}
                          controls
                          style={{ objectFit: 'cover' }}
                        >
                          <source src={requestDetails.s3_file_name} type={requestDetails.file_type} />
                          Your browser does not support the video tag.
                        </video>
                        : ["application/x-photoshop"].includes(requestDetails?.file_type) ?
                          <>{
                            psdImageData?.error ? 
                            <p class="text-red-600 font-semibold">
                            PSD preview failed. File may be too large or unsupported.
                          </p>
                            : 

                            <img
                              alt=""
                              className={`rounded w-full object-cover`}
                              src={psdImageData}
                            />
                          }
                          

                          </>
                          :
                          <img
                            alt=""
                            className={`rounded h-[100px]  object-cover`}
                            src={requestDetails?.s3_file_name
                              ? getFileIcon(requestDetails.file_type)
                              : fileIcon
                            }
                          />
                  }
                </div>
              }
              onClose={() => setOpenMediaViewer(false)}
              title="Media Preview"
            />
          : <></>



      }


      {/* <div className="w-full flex text-xs px-4">
        {["Assigned", "Approved", "Rejected"].map((item) => (
          <button
            key={item}
            onClick={() => setCreativeTab(item)}
            className={`px-4 py-2  text-black ${
              creativeTab === item
                ? "border-t-2 border-blue-500 bg-blue-100"
                : "bg-transparent"
            }`}
          >
            {item}
          </button>
        ))}
      </div> */}
      <CreativeTable
        headers={
          creativeUploadRoles.includes(userRole)
            ? creativeUploadHeaders
            : creativeApproveAndRejectRoles.includes(userRole)
              ? creativeHeaders
              : []
        }
        userRole={userRole}
        data={filteredData}
        rows={10}
        rowAction={
          creativeApproveAndRejectRoles.includes(
            JSON.parse(sessionStorage.getItem("user"))?.role
          )

            // ||
            // creativeClientRejectApproveAccess.includes(
            //   JSON.parse(sessionStorage.getItem("user"))?.role
            // ) || 
            // reassignRequestAccess.includes(
            //   JSON.parse(sessionStorage.getItem("user"))?.role
            // )

            ? true
            : false
        }
        cellFunctionIndex={[1, 2]}
        cellFunction={(d) => {
          setOpenReqSidebar(true);
          setRequestDetails(d);
        }}
        accountName={accountName}
        rowActionHeadName="Action"
        setOpenCreativeUpload={setOpenCreativeUpload}
        setReassignedCreativeItem={setReassignedCreativeItem}
      />
      {/* <FolderDialog
        isOpen={openReqSidebar}
        onClose={() => setOpenReqSidebar(false)}
        title={"Creative popup"}
        content={
         <></>
        }
      /> */}
      <RightSidebar
        isOpen={openReqSidebar}
        width={"w-[40%]"}
        onClose={() => setOpenReqSidebar(false)}
        title={"Request Details"}
        content={
          <div className="text-sm">
            <div className={`mx-auto flex rounded items-center justify-center h-[250px] w-[100%] ${(requestDetails?.file_type?.startsWith('image/') || requestDetails?.file_type?.startsWith('video/') || ["application/x-photoshop"].includes(requestDetails?.file_type)) && "cursor-pointer"} `} onClick={() => {
              if (requestDetails?.file_type?.startsWith('image/') || requestDetails?.file_type?.startsWith('video/') || ["application/x-photoshop"].includes(requestDetails?.file_type)) {
                setOpenMediaViewer(true);
                setOpenReqSidebar(false);
                setPsdImageData(null);
                ["application/x-photoshop"].includes(requestDetails?.file_type) && convertPSDImageHandler(requestDetails);
              }

            }
            }>
              {" "}
              {
                requestDetails?.file_type?.startsWith('image/') ?
                  <img
                    alt=""
                    className={`rounded w-full h-[250px]  object-cover`}
                    src={requestDetails.s3_file_name}
                  />
                  : requestDetails?.file_type?.startsWith('video/') ?
                    <video
                      className={`rounded w-full h-[250px]  object-cover`}
                      controls
                      style={{ objectFit: 'cover' }}
                    >
                      <source src={requestDetails.s3_file_name} type={requestDetails.file_type} />
                      Your browser does not support the video tag.
                    </video>
                    :
                    <img
                      alt=""
                      className={`rounded h-[100px]  object-cover`}
                      src={requestDetails?.s3_file_name
                        ? getFileIcon(requestDetails.file_type)
                        : fileIcon
                      }
                    />
              }
            </div>
            <div>
              <div className="flex flex-col justify-between ">
                <div className="creative_popup_row">
                  <span className="w-[50%]">Name</span>
                  <span className="w-[50%] text-[#7C7E81]">
                    {requestDetails?.requestName}
                  </span>
                </div>
                <div className="creative_popup_row">
                  <span className="w-[50%]">Request for Proposal</span>
                  <span className="w-[50%] text-[#7C7E81]">
                    {requestDetails?.assignedBy?.user_name}
                  </span>
                </div>
                <div className="creative_popup_row">
                  <span className="w-[50%]">Request For</span>
                  <span className="w-[50%] text-[#7C7E81]">
                    {`${requestDetails?.channel?.toUpperCase()}${requestDetails?.assignedTo?.[0]?.zone ? " - " + requestDetails?.assignedTo?.[0]?.zone : ""}${requestDetails?.assignedTo?.[0]?.region ? " - " + requestDetails?.assignedTo?.[0]?.region : ""} `}
                  </span>
                </div>
                <div className="creative_popup_row">
                  <span className="w-[50%]">Requested date</span>
                  <span className="w-[50%] text-[#7C7E81]">
                    {(() => {
                      const dateObj = new Date(requestDetails?.createdAt);
                      const day = dateObj.getDate();
                      const month = dateObj.toLocaleDateString("en-GB", {
                        month: "short",
                      });
                      const year = dateObj.getFullYear();
                      const time = dateObj.toLocaleTimeString("en-US", {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                      });
                      return `${day} ${month} ${year} ${time}`;
                    })()}
                  </span>
                </div>

                <div className="creative_popup_row">
                  <span className="w-[50%]">{`${requestDetails?.status === "Rejected" ? "Rejected By" : "Approved By"}`} </span>
                  <span className="w-[50%] text-[#7C7E81]">
                    {requestDetails?.approvedBy?.user_name || requestDetails?.approvedBy?.email || "-"}
                  </span>
                </div>
                <div className="creative_popup_row">
                  <span className="w-[50%]">{`${requestDetails?.status === "Rejected" ? "Rejected Date" : "Approved Date"}`} </span>
                  <span className="w-[50%] text-[#7C7E81]">
                    {requestDetails?.approvedBy?.approvedDate || requestDetails?.approvedBy?.updatedAt ? moment(requestDetails?.approvedBy?.approvedDate || requestDetails?.approvedBy?.updatedAt).format("DD MMM YYYY") : "-"}
                  </span>
                </div>
                {requestDetails?.reject_reason &&
                  requestDetails?.status === "Rejected" && (
                    <div className="creative_popup_row">
                      <span className="w-[50%]">Reason</span>
                      <span className="w-[50%] text-[#7C7E81]">
                        {requestDetails.reject_reason}
                      </span>
                    </div>
                  )}

                <div className="creative_popup_row !border-b-0">
                  <span className="w-[50%]">Status:</span>
                  <span className="w-[50%]">
                    <div className="flex gap-2">
                      <button
                        type="button"
                        className={`approveBtn ${requestDetails?.status === "Approved"
                          ? "bg-green-500 text-white"
                          : ""
                          }`}
                      >
                        {requestDetails?.status}
                      </button>

                      {/* <button type="button" className="rejectBtn">
                        Reject
                      </button> */}
                    </div>
                    {/* <ActionDropdown
                  requestId={requestDetails?._id}
                  currentTab={creativeTab}
                  userRole={userRole}
                  status={requestDetails?.status}
                  accountName={accountName}
                  onclose={() => setOpenReqSidebar(false)}
                /> */}
                  </span>
                </div>
                {/* {requestDetails?.status !== "Approved" && (
                  <div className="creative_popup_reason">
                    <label>Reason :</label>
                    <textarea
                      placeholder="Rejection reason"
                      className="border p-2 rounded"
                    ></textarea>
                  </div>
                )} */}



                {/* <div>
              {requestDetails.status === "Rejected" &&
                reassignRequestAccess.includes(
                  JSON.parse(sessionStorage.getItem("user")).role
                ) && (
                  <button
                    className="bg-blue-500 w-[fit-content] p-2 rounded text-white"
                    onClick={() =>
                      reAssignAlert(
                        user._id,
                        requestDetails._id,
                        requestDetails?.assignedTo.email
                      )
                    }
                  >
                    Reopen request
                  </button>
                )}
            </div> */}
                <button
                  type="button"
                  className="downloadBtn mt-1 md:mt-2 lg:mt-4"
                  onClick={() => handleDownload(requestDetails.s3_file_name)}
                >
                  <img src={downloadIcon} alt="logo" /> Download
                </button>
              </div>
            </div>


          </div>
        }
      />
    </div>
  );
};

export default CreativeApproval;
